import { useQuery } from "@apollo/client";
import { FormControl } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select, { SingleValue } from "react-select";
import { GET_SUB_CATEGORIES } from "src/graphql/query";

// Define types for props
interface SubCategoryOption {
  value: string;
  label: string;
}

interface SubCategoryDropDownProps {
  selectedCategory: string | null;
  selectedSubCategory: string | null;
  handleSubCategoryChange: (
    selectedOption: SingleValue<SubCategoryOption>
  ) => void;
}

const SubCategoryDropDown: React.FC<SubCategoryDropDownProps> = ({
  selectedSubCategory,
  handleSubCategoryChange,
  selectedCategory,
}) => {
  const [subCategories, setSubCategories] = useState<SubCategoryOption[]>([]);
  const { data: subCategoryData } = useQuery(GET_SUB_CATEGORIES, {
    variables: {
      _id: selectedCategory,
    },
    skip: !selectedCategory,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (subCategoryData) {
      const fetchedSubCategories =
        subCategoryData?.getCategory?.data?.subCategory?.map(
          (sub: { subCategoryName: string; _id: string }) => ({
            value: sub._id,
            label: sub.subCategoryName,
          })
        );
      setSubCategories(fetchedSubCategories || []);
    }
  }, [subCategoryData]);

  return (
    <FormControl fullWidth sx={{ zIndex: "9999" }}>
      <Select
        value={subCategories.find(
          (option) => option.value === selectedSubCategory
        )}
        maxMenuHeight={300}
        placeholder="Select Subcategory"
        options={subCategories}
        onChange={handleSubCategoryChange}
        isDisabled={!selectedCategory}
      />
    </FormControl>
  );
};

export default SubCategoryDropDown;
